export const DS_FIELDS_TABLE_REF_SEPARATOR = '-';
